import { red } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#000000',
    },
    secondary: {
      main: '#A67D3D',
    },
    error: {
      main: red[600],
    },
    background: {
      default: '#c5281c',
    },
  },
});

export default theme;
